import { useDispatch, useSelector } from "react-redux";
import { selector as groupApi, groupList } from '../pages/deviceManagement/groupSlice';
import { useEffect } from "react";
import { _updateUser } from "../pages/users/userSlice";
import { getRoleName, isAuthenticated } from "../common/utils";
import { roleIds } from "../config";

const useAppStartup = () => {
    const dispatch = useDispatch();
    const isListGroupsLoaded: boolean = useSelector(groupApi).isLoaded;
    const userRoleName: string = getRoleName();

    useEffect(() =>{
            // Simulating cookie retrieval
            const cookies = document.cookie.split(';').reduce((acc, cookie) => {
               const [name, value] = cookie.trim().split('=');
               return { ...acc, [name]: value };
           }, {});
   
           // Dispatching action to save cookies in userSlice
           dispatch(_updateUser(cookies));
    
    }, [dispatch]);

    useEffect(() => {
        if(isAuthenticated() && !isListGroupsLoaded && userRoleName !== roleIds.superAdmin) {
            dispatch(groupList());
        }  
    }, [dispatch, isListGroupsLoaded])
}
 
export default useAppStartup;